import React, { useEffect, useState } from "react";
import AnalyzeIcon from "../assets/images/analyzeIcon.png";
import AnalyticsIcon from "../assets/images/analyticsIcon.png";
import Mangnifer from "../assets/images/Magnifier.png";
import { useDispatch, useSelector } from "react-redux";
import { getPositionsData } from "../store/Slice/PositionSlice";

const Positions = () => {
  const { userId } = useSelector((state) => state.auth);
  const { data, loading } = useSelector((state) => state.position);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  const getPositions = () => {
    dispatch(getPositionsData(userId));
  };

  useEffect(() => {
    getPositions();
  }, []);

  const handleCheckboxChange = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div className="w-full">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-8 px-8 gap-4">
        <div>
          <h2 className="text-2xl font-semibold">Positions({data[0]?.length})</h2>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Search Box */}
          <div className="flex items-center">
            <div className="bg-brand-gray border border-brand-border rounded-l-lg px-2 py-2.5 flex items-center">
              <img src={Mangnifer} alt="magnifier" className="w-5 h-5" />
            </div>
            <input
              type="text"
              className="bg-brand-gray border-r border-t border-b border-brand-border rounded-r-lg px-3 py-2 outline-none placeholder:text-gray-400 mr-4"
              placeholder="search"
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
            />
          </div>

          {/* Action Icons */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2 cursor-pointer">
              <img src={AnalyzeIcon} alt="analyze" className="w-5 h-5" />
              <p className="text-[#f66464] text-base">Analyze</p>
            </div>
            <div className="flex items-center gap-2 cursor-pointer">
              <img src={AnalyticsIcon} alt="analytics" className="w-5 h-5" />
              <p className="text-primary text-base">Analytics</p>
            </div>
            <div className="flex items-center gap-2 cursor-pointer">
              <img src={AnalyticsIcon} alt="download" className="w-5 h-5" />
              <p className="text-primary text-base">Download</p>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="mt-12 overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="h-[3.3rem] shadow-[0px_4px_6px_rgba(0,0,0,0.1)]">
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border"></th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">Product</th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">Instrument</th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">Qty.</th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">Avg.</th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">LTP</th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">P&L</th>
              <th className="text-gray-400 font-normal text-xl border-t border-brand-border">Chg.</th>
            </tr>
          </thead>
          <tbody>
            {data[0]?.length > 0 &&
              data[0]
                ?.filter((h) => {
                  console.log(h, searchTerm);
                  return searchTerm == ""
                    ? h
                    : h?.instrument?.toLowerCase().includes(searchTerm);
                })
                ?.map((position, index) => (
                  <tr key={index} className="h-12 border-b border-brand-border">
                    <td className="text-center text-xl">
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(index)}
                        onChange={() => handleCheckboxChange(index)}
                        className="w-4 h-4 cursor-pointer"
                      />
                    </td>
                    <td className="text-center text-xl">
                      <span className="inline-block bg-[rgba(131,53,253,0.31)] text-[#8335FD] font-bold px-3 py-1 rounded">
                        {position?.product}
                      </span>
                    </td>
                    <td className="text-center text-xl">{position?.instrument}</td>
                    <td className="text-center text-xl text-primary">{position?.quantity}</td>
                    <td className="text-center text-xl">{position?.averageCost}</td>
                    <td className="text-center text-xl text-[#9be931]">{position?.ltp}</td>
                    <td className="text-center text-xl text-[#9be931]">{position?.pnl}</td>
                    <td className="text-center text-xl text-[#9be931]">{position?.change}%</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Positions;
